/* eslint-disable */
import React, { useState } from "react";
import {
  Box, Flex, Heading, Text, VStack, HStack, Button,
  Icon, Input, InputGroup, InputLeftElement, Avatar,
  Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerBody, Spinner,
  useDisclosure, useColorModeValue, useColorMode, Switch, FormLabel,
  Menu, MenuButton, MenuList, MenuItem
} from "@chakra-ui/react";
import {
  FaSearch, FaBell, FaBrain, FaThLarge, FaBookOpen, FaVideo,
  FaCheckCircle, FaCertificate, FaCog, FaSignOutAlt, FaTags, FaUsers, FaChartBar, FaUserShield, FaEnvelope, FaChartLine
} from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import axios from "axios";
import EmailOutboxDrawer from "./EmailOutboxDrawer";
import { useLanguage } from "../../context/LanguageContext";
import { Select } from "@chakra-ui/react";

const UserLayout = ({ children }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { colorMode, toggleColorMode } = useColorMode();
  const isDark = colorMode === "dark";
  const { language, toggleLanguage, t } = useLanguage();

  // AI Mentor State
  const { isOpen: isAiOpen, onOpen: onAiOpen, onClose: onAiClose } = useDisclosure();
  const { isOpen: isOutboxOpen, onOpen: onOutboxOpen, onClose: onOutboxClose } = useDisclosure();
  const [messages, setMessages] = useState([
    { sender: "ai", text: "Hello! I am Eram Pilot. 🌟\n\nI can recommend the perfect training courses for your role, tell you about current compliance assignments, or explain any professional concept or technical term. What would you like to learn today?" }
  ]);
  const [aiInput, setAiInput] = useState("");
  const [isAiLoading, setIsAiLoading] = useState(false);

  // Theme Colors
  const bgMain = isDark ? "var(--bg-page, #0D0B1A)" : "#ffffff";
  const sidebarBg = isDark ? "var(--bg-surface, #161428)" : "white";
  const sidebarBorder = isDark ? "var(--border-soft, rgba(255, 255, 255, 0.08))" : "#eef2f0";
  const textDark = isDark ? "var(--text-main, #EDE9FF)" : "#0a2628";
  const textMuted = isDark ? "var(--text-muted, #9B98BC)" : "#7a9c9f";

  const drawerBg = isDark ? "gray.900" : "white";
  const drawerBodyBg = isDark ? "gray.800" : "gray.50";
  const aiMessageBg = isDark ? "gray.700" : "white";
  const aiMessageColor = isDark ? "gray.100" : "gray.800";
  const aiMessageBorder = isDark ? "gray.600" : "gray.150";
  const inputBg = isDark ? "gray.900" : "white";
  const inputBorder = isDark ? "gray.700" : "gray.100";

  const localUser = JSON.parse(localStorage.getItem("user")) || {};
  const userRole = localUser.role || "user";
  const uName = localUser.name || localUser.user?.fullName || "Student";
  const token = localUser.token || "";

  const handleSendAi = async () => {
    if (!aiInput.trim()) return;
    const textToSend = aiInput;
    setMessages(prev => [...prev, { sender: "user", text: textToSend }]);
    setAiInput("");
    setIsAiLoading(true);

    try {
      const token = JSON.parse(localStorage.getItem('user'))?.token;
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/courses/dashboard/ask-ai`, {
        question: textToSend
      }, { headers: { Authorization: `Bearer ${token}` } });
      setMessages(prev => [...prev, { sender: "ai", text: response.data.answer }]);
    } catch (err) {
      console.error(err);
      const errMsg = err.response?.data?.message || err.response?.data || "Sorry, I ran into an issue answering your question.";
      setMessages(prev => [...prev, { sender: "ai", text: errMsg }]);
    } finally {
      setIsAiLoading(false);
    }
  };

  const handleLogout = () => {
    if (token) {
      axios.post(`${process.env.REACT_APP_API_URL}/api/auth/logout`, {}, { headers: { Authorization: `Bearer ${token}` } })
        .catch(err => console.log(err));
    }
    dispatch({ type: "USER_LOGOUT" });
    navigate("/");
  };

  const SidebarItem = ({ icon, label, path, targetId, onClick, exact = false }) => {
    const active = location.pathname === path && (path !== "/home" || label === "Dashboard" || label === "User Dashboard");
    const activeBg = isDark ? "var(--primary, #9D94F8)" : textDark;
    const activeColor = isDark ? "white" : "white";
    const hoverBg = isDark ? "var(--bg-raised, #1E1B35)" : "gray.50";

    const handleClick = () => {
      if (onClick) {
        onClick();
        return;
      }
      if (targetId) {
        if (location.pathname !== path) {
          navigate(path);
          setTimeout(() => {
            const el = document.getElementById(targetId);
            if (el) el.scrollIntoView({ behavior: 'smooth' });
          }, 300);
        } else {
          const el = document.getElementById(targetId);
          if (el) el.scrollIntoView({ behavior: 'smooth' });
        }
      } else {
        navigate(path);
      }
    };

    return (
      <Flex
        align="center" p={3} mb={2} borderRadius="full" cursor="pointer"
        bg={active ? activeBg : "transparent"}
        color={active ? activeColor : textMuted}
        _hover={{ bg: active ? activeBg : hoverBg, color: active ? activeColor : textDark }}
        onClick={handleClick}
        transition="all 0.2s"
      >
        <Icon as={icon} mr={4} boxSize={4} />
        <Text fontSize="sm" fontWeight={active ? "800" : "700"} color={active ? activeColor : "inherit"}>{label}</Text>
      </Flex>
    );
  };

  return (
    <Flex h="100vh" bg={bgMain} overflow="hidden" fontFamily="Outfit, Poppins, sans-serif">
      {/* ── SIDEBAR ── */}
      <Box 
        w="250px" 
        bg={sidebarBg} 
        borderRight="1px solid" 
        borderColor={sidebarBorder} 
        p={6} 
        display={{ base: "none", lg: "block" }}
        overflowY="auto"
        css={{
          "&::-webkit-scrollbar": { display: "none" },
          msOverflowStyle: "none",
          scrollbarWidth: "none"
        }}
      >
        <Flex align="center" mb={10} onClick={() => navigate("/home")} cursor="pointer">
          <img src="/Workforce.svg" alt="Workforce Logo" style={{ height: "100px", marginRight: "12px", filter: colorMode === 'dark' ? 'brightness(0) invert(1)' : 'none' }} />
          <Heading size="md" color={textDark} fontWeight="900" letterSpacing="-0.5px">SkillUp</Heading>
        </Flex>

        {(userRole === "user" || userRole === "employee") && (
          <>
            <Text fontSize="10px" fontWeight="800" color={textMuted} mb={4} mt={6} letterSpacing="1px">LEARNING</Text>
            <SidebarItem icon={FaThLarge} label="Employee Dashboard" path="/home" targetId="dashboard-top" />
            <SidebarItem icon={FaBookOpen} label="My Courses" path="/home" targetId="my-courses" />
            <SidebarItem icon={FaVideo} label="Live Sessions" path="/home" targetId="live-sessions" />
            <SidebarItem icon={FaBrain} label="LNA Quizzes" path="/lna-quizzes" />

            <Text fontSize="10px" fontWeight="800" color={textMuted} mb={4} mt={8} letterSpacing="1px">ACHIEVEMENTS</Text>
            <SidebarItem icon={FaCheckCircle} label="Completed" path="/home" targetId="completed-courses" />
            <SidebarItem icon={FaCertificate} label="Certificates" path="/home" targetId="completed-courses" />
            <SidebarItem icon={FaChartLine} label="My Insights" path="/my-insights" />

            <Text fontSize="10px" fontWeight="800" color={textMuted} mb={4} mt={8} letterSpacing="1px">COMMUNICATION</Text>
            <SidebarItem icon={FaEnvelope} label="Mail Service" onClick={onOutboxOpen} />
          </>
        )}

        {(userRole === "admin" || userRole === "super_admin") && (
          <>
            <Text fontSize="10px" fontWeight="800" color={textMuted} mb={4} mt={6} letterSpacing="1px">DASHBOARD</Text>
            <SidebarItem icon={FaThLarge} label="Employee Dashboard" path="/home" />
            <SidebarItem icon={FaChartBar} label="Admin Dashboard" path="/admin/dashboard" />

            <Text fontSize="10px" fontWeight="800" color={textMuted} mb={4} mt={8} letterSpacing="1px">MANAGEMENT</Text>
            <SidebarItem icon={FaTags} label="Categories" path="/admin/categories" />
            <SidebarItem icon={FaBookOpen} label="Courses" path="/admin/courses" />
            <SidebarItem icon={FaUsers} label="Users" path="/admin/users" />
            <SidebarItem icon={FaUsers} label="Project Groups" path="/admin/groups" />
            <SidebarItem icon={FaUserShield} label="Instructor Insights" path="/admin/teacher-insights" />
            <SidebarItem icon={FaChartLine} label="Employee Insights" path="/admin/employee-insights" />
            <SidebarItem icon={FaBrain} label="LNA Quiz Admin" path="/admin/upload-lna-quiz" />

            <Text fontSize="10px" fontWeight="800" color={textMuted} mb={4} mt={8} letterSpacing="1px">COMMUNICATION</Text>
            <SidebarItem icon={FaEnvelope} label="Mail Service" onClick={onOutboxOpen} />
          </>
        )}

        {userRole === "instructor" && (
          <>
            <Text fontSize="10px" fontWeight="800" color={textMuted} mb={4} mt={6} letterSpacing="1px">DASHBOARD</Text>
            <SidebarItem icon={FaThLarge} label="Employee Dashboard" path="/home" />
            <SidebarItem icon={FaChartBar} label="Instructor Dashboard" path="/teacher-dashboard" />

            <Text fontSize="10px" fontWeight="800" color={textMuted} mb={4} mt={8} letterSpacing="1px">MANAGEMENT</Text>
            <SidebarItem icon={FaBookOpen} label="Courses" path="/Teacher/courses" />
            <SidebarItem icon={FaUsers} label="Users" path="/Teacher/users" />

            <Text fontSize="10px" fontWeight="800" color={textMuted} mb={4} mt={8} letterSpacing="1px">COMMUNICATION</Text>
            <SidebarItem icon={FaEnvelope} label="Mail Service" onClick={onOutboxOpen} />
          </>
        )}

 <Text fontSize="10px" fontWeight="800" color={textMuted} mb={4} mt={8} letterSpacing="1px">ACCOUNT</Text>
        <SidebarItem icon={FaCog} label="Settings" path={(userRole === 'user' || userRole === 'employee') ? "/profile" : "/admin/setting"} />

{(userRole === "admin" || userRole === "super_admin") && (
  <SidebarItem icon={FaCertificate} label="Certificate Generator" path="/admin/certificates" />
)}
</Box>

      {/* ── MAIN CONTENT AREA ── */}
      <Flex flex="1" direction="column" h="100%" overflow="hidden">
        {/* Top Header */}
        <Flex h="80px" align="center" justify="space-between" px={{ base: 4, md: 8 }} flexShrink={0} borderBottom={colorMode === 'dark' ? "1px solid var(--border-soft)" : "none"}>
          <InputGroup maxW="300px" bg={sidebarBg} borderRadius="full" display={{ base: "none", md: "block" }}>
            <InputLeftElement pointerEvents="none" top="-1px" left="2px">
              <Icon as={FaSearch} color={textMuted} boxSize={3.5} />
            </InputLeftElement>
            <Input
              border="1px solid" borderColor={sidebarBorder} borderRadius="full" placeholder="Search courses..."
              fontSize="xs" fontWeight="700" bg={sidebarBg} color={textDark}
              _placeholder={{ color: textMuted }}
            />
          </InputGroup>

          <HStack spacing={5} ml="auto">
            {/* Language Toggle */}
            <Select 
              value={language} 
              onChange={toggleLanguage} 
              size="sm" 
              width="80px" 
              borderRadius="md"
              bg="purple.50"
              borderColor="purple.300"
              color="purple.800"
              fontWeight="bold"
            >
              <option value="en">EN</option>
              <option value="ar">AR</option>
            </Select>

            {/* Dark Mode Toggle */}
            <Flex align="center">
              <FormLabel htmlFor="dark-mode-toggle" mb="0" mr={2} fontSize="sm" fontWeight="800" cursor="pointer">
                {colorMode === "light" ? "🌙" : "☀️"}
              </FormLabel>
              <Switch id="dark-mode-toggle" colorScheme="teal" isChecked={colorMode === "dark"} onChange={toggleColorMode} />
            </Flex>

            <Menu>
              <MenuButton>
                <Flex align="center" cursor="pointer">
                  <Avatar size="sm" name={uName} src="" mr={3} border="2px solid" borderColor={sidebarBg} boxShadow="0 2px 10px rgba(0,0,0,0.05)" />
                  <VStack align="start" spacing={0} display={{ base: "none", lg: "flex" }}>
                    <Text fontSize="xs" fontWeight="800" color={textDark}>{uName}</Text>
                    <Text fontSize="10px" fontWeight="600" color={textMuted} textTransform="capitalize">{userRole.replace('_', ' ')}</Text>
                  </VStack>
                </Flex>
              </MenuButton>
              <MenuList>
                <MenuItem icon={<FaCog />} onClick={() => navigate((userRole === 'user' || userRole === 'employee') ? "/profile" : "/admin/setting")}>Settings</MenuItem>
                <MenuItem icon={<FaSignOutAlt />} color="red.500" onClick={handleLogout}>Logout</MenuItem>
              </MenuList>
            </Menu>
          </HStack>
        </Flex>

        {/* Scrollable Children Body */}
        <Box flex="1" overflowY="auto" p={{ base: 4, md: 8 }}>
          {children}
        </Box>
      </Flex>

      {/* ── FLOATING AI MENTOR ── */}
      {JSON.parse(localStorage.getItem('user'))?.token && (
        <>
          <Button
            position="fixed"
            bottom={8}
            right={8}
            bg="#e7f9d5"
            color="#0a2628"
            _hover={{ bg: "#d4f0b9", transform: "translateY(-3px)", boxShadow: "0 12px 28px rgba(0,0,0,0.15)" }}
            transition="all 0.25s cubic-bezier(0.16,1,0.3,1)"
            borderRadius="full"
            h="54px"
            px={7}
            boxShadow="0 6px 20px rgba(0,0,0,0.1)"
            zIndex={1000}
            leftIcon={<Icon as={FaBrain} />}
            onClick={onAiOpen}
            fontSize="sm"
            fontWeight="800"
          >
            Ask Eram Pilot
          </Button>

          <Drawer isOpen={isAiOpen} placement="right" onClose={onAiClose} size="md">
            <DrawerOverlay backdropFilter="blur(4px)" />
            <DrawerContent borderLeftRadius="2xl" overflow="hidden" bg={drawerBg}>
              <DrawerCloseButton color="white" zIndex={2000} />

              <Box bgGradient="linear(to-r, teal.500, blue.500)" p={6} color="white">
                <Flex align="center" gap={3}>
                  <Icon as={FaBrain} w={6} h={6} />
                  <Box>
                    <Heading size="md" fontWeight="800">Eram Pilot</Heading>
                    <Text fontSize="xs" opacity={0.9}>Corporate Pathway & Recommendation AI</Text>
                  </Box>
                </Flex>
              </Box>

              <DrawerBody bg={drawerBodyBg} p={4} display="flex" flexDir="column" gap={4} overflowY="auto">
                <Flex direction="column" gap={3} flex={1}>
                  {messages.map((m, idx) => (
                    <Flex key={idx} justify={m.sender === 'user' ? 'flex-end' : 'flex-start'}>
                      <Box
                        maxW="80%" p={3.5} borderRadius="2xl"
                        bgGradient={m.sender === 'user' ? 'linear(to-r, teal.500, blue.500)' : undefined}
                        bg={m.sender === 'user' ? undefined : aiMessageBg}
                        color={m.sender === 'user' ? 'white' : aiMessageColor}
                        boxShadow="sm" fontSize="sm"
                        border={m.sender === 'ai' ? '1px solid' : 'none'}
                        borderColor={aiMessageBorder}
                      >
                        <Text whiteSpace="pre-line">{m.text}</Text>
                      </Box>
                    </Flex>
                  ))}
                  {isAiLoading && (
                    <Flex justify="flex-start">
                      <Box maxW="80%" p={3.5} borderRadius="2xl" bg={aiMessageBg} shadow="sm" border="1px solid" borderColor={aiMessageBorder}>
                        <Spinner size="xs" color="teal.500" />
                      </Box>
                    </Flex>
                  )}
                </Flex>
              </DrawerBody>

              <Box p={4} bg={inputBg} borderTop="1px solid" borderColor={inputBorder}>
                <Flex gap={2}>
                  <Input
                    placeholder="Ask for recommendations or guidance..."
                    value={aiInput}
                    onChange={(e) => setAiInput(e.target.value)}
                    onKeyDown={(e) => e.key === 'Enter' && handleSendAi()}
                    borderRadius="xl"
                  />
                  <Button bgGradient="linear(to-r, teal.500, blue.500)" _hover={{ bgGradient: "linear(to-r, teal.600, blue.600)" }} color="white" borderRadius="xl" onClick={handleSendAi}>Send</Button>
                </Flex>
              </Box>
            </DrawerContent>
          </Drawer>
        </>
      )}
      <EmailOutboxDrawer isOpen={isOutboxOpen} onClose={onOutboxClose} />
    </Flex>
  );
};

export default UserLayout;
